import {
    Attachment,
    Avatar,
    Button,
    Divider,
    EditIcon,
    FilesPdfColoredIcon,
    Flex,
    Image,
    OpenOutsideIcon,
    Skeleton,
    Text,
} from "@fluentui/react-northstar";
import styled from "styled-components/macro";
import WelcomeImg from "../img/bgBulle.svg";
import { DocumentColor } from "@fluentui/react-icons";
import Footer from "./Footer";
import DocumentComponent from "./DocumentComponent";
import { _preonboarding, _submitFactsheet } from "../api";
import { useMutation, useQuery } from "react-query";

import { DEVICE, DEVICE_MAX } from "../../../constants/responsive";
import withAuth from "../../../HOC/withAuth";
import SCHeaderPreOnboarding from "./SCHeaderPreOnboarding";
import { ProgressBar } from "@fluentui/react-components";
import moment from "moment";
import { ROUTES } from "../../../constants/routes";
import { useNavigate } from "react-router-dom";

const WelcomePreonboarding = () => {
    const navigate = useNavigate();
    const {
        isLoading: isLoadingData,
        isFetching,
        data,
    } = useQuery(["preonboarding_information"], () => _preonboarding());
    const formatedDueDate = data?.me?.completeness_due_date
        ? moment(data?.me?.completeness_due_date).format("D MMM YYYY")
        : "--";
    const isLoading = isLoadingData || isFetching;
    return (
        <FooterContent fill column>
            <SCHeaderPreOnboarding arrival_date={data?.me?.arrival_date} />
            <SFlexPage fill>
                <SFlexLeftCol>
                    <SFlexWelcomeBlock column>
                        {isLoading ? (
                            <Skeleton animation="pulse">
                                <Skeleton.Line width="80%" height="26px" />
                            </Skeleton>
                        ) : (
                            <STextWelcomeTitle
                                content={`Bonjour ${data?.me?.first_name}, et bienvenue chez nous ! 🎉`}
                            />
                        )}

                        <SFlexWelcomeBody>
                            {isLoading ? (
                                <Skeleton animation="pulse">
                                    <Flex gap="gap.smaller" column>
                                        <Skeleton.Line
                                            width="100%"
                                            height="18px"
                                        />
                                        <Skeleton.Line
                                            width="50%"
                                            height="18px"
                                        />
                                        <Skeleton.Line
                                            width="45%"
                                            height="18px"
                                        />
                                    </Flex>
                                </Skeleton>
                            ) : (
                                <>
                                    <STextWelcolmeDescription
                                        content={`Pour préparer votre arrivée dans les meilleures conditions, nous vous invitons à réaliser ces deux étapes avant votre premier jour :`}
                                    />
                                    <Text
                                        content={`1. Complétez votre fiche d'engagement`}
                                        className="strong"
                                    />
                                    <Text
                                        content={`2. Consultez et transmettez vos documents`}
                                        className="strong"
                                    />
                                </>
                            )}
                        </SFlexWelcomeBody>
                        {isLoading && (
                            <Skeleton animation="pulse">
                                <Flex
                                    styles={{
                                        marginBottom: "22px",
                                    }}
                                >
                                    <Skeleton.Line width="80%" height="48px" />
                                </Flex>
                            </Skeleton>
                        )}
                        {data?.contract_document_url?.length !== 0 &&
                            !isLoading && (
                                <Flex
                                    styles={{
                                        marginBottom: "22px",
                                    }}
                                >
                                    <Attachment
                                        actionable
                                        action={{
                                            icon: <OpenOutsideIcon />,
                                        }}
                                        icon={<FilesPdfColoredIcon />}
                                        header={`Contrat de travail de ${data?.me?.first_name}.pdf`}
                                        flat
                                        styles={{
                                            boxShadow: "none",
                                        }}
                                    />
                                    <DividerStyle />
                                </Flex>
                            )}
                        <SFlexContact>
                            {isLoading ? (
                                <Skeleton animation="pulse">
                                    <Flex gap="gap.medium">
                                        <Flex gap="gap.medium">
                                            <Skeleton.Avatar size="large" />
                                        </Flex>
                                        <Flex column vAlign="center">
                                            <Skeleton.Line
                                                width="126px"
                                                height="20px"
                                            />
                                            <Skeleton.Line
                                                width="100px"
                                                height="17px"
                                            />
                                        </Flex>
                                    </Flex>
                                </Skeleton>
                            ) : (
                                <Flex gap="gap.medium">
                                    <Avatar
                                        name={data?.hr?.name ?? ""}
                                        image={data?.hr?.avatar ?? ""}
                                        size="large"
                                    />
                                    <Flex column vAlign="center">
                                        <STextFullname
                                            content={data?.hr?.name ?? ""}
                                        />
                                        <STextJobTitle
                                            content={data?.hr?.job_title ?? ""}
                                        />
                                    </Flex>
                                </Flex>
                            )}
                            <SFlexContactRight>
                                {isLoading ? (
                                    <Skeleton animation="pulse">
                                        <Skeleton.Line
                                            width="120px"
                                            height="20px"
                                        />
                                        <Skeleton.Line
                                            width="100px"
                                            height="20px"
                                        />
                                    </Skeleton>
                                ) : (
                                    <>
                                        <STextLink
                                            as="a"
                                            href={`mailto:${
                                                data?.hr?.email ?? ""
                                            }`}
                                        >
                                            {data?.hr?.email ?? ""}
                                        </STextLink>
                                        <STextLink
                                            as="a"
                                            href={`tel:${
                                                data?.hr?.phone ?? ""
                                            }`}
                                        >
                                            {data?.hr?.phone ?? ""}
                                        </STextLink>
                                    </>
                                )}
                            </SFlexContactRight>
                        </SFlexContact>
                    </SFlexWelcomeBlock>
                    <SFlexWelcomeImageBlock>
                        <Flex hAlign="center" fill>
                            <ImageStyle src={WelcomeImg ?? ""} />
                        </Flex>
                    </SFlexWelcomeImageBlock>
                </SFlexLeftCol>
                <SFlexRightCol>
                    <SFlexEnrollementForm column>
                        <SFlexTop vAlign="center">
                            <SFlexTopIcon>
                                <DocumentColor />
                            </SFlexTopIcon>
                            <STextTitle content="Votre fiche d'engagement" />
                        </SFlexTop>
                        <SFlexBody>
                            <STextDescription content="Renseignez vos informations personnelles, vos coordonnées bancaires et vos données de contact d'urgence. Une fois complétée, votre fiche sera transmise à votre responsable RH pour validation." />
                        </SFlexBody>
                        <SFlexProgress column>
                            <SFlexProgressLabel fill>
                                <STextProgress content="Complétude — champs obligatoires" />
                                {isLoading ? (
                                    <Flex>
                                        <Skeleton animation="pulse">
                                            <Skeleton.Line
                                                width="34px"
                                                height="20px"
                                            />
                                        </Skeleton>
                                    </Flex>
                                ) : (
                                    <STextPercent
                                        content={`${
                                            data?.me?.completeness_percentage ??
                                            ""
                                        } %`}
                                    />
                                )}
                            </SFlexProgressLabel>
                            <ProgressBar
                                value={
                                    (data?.me?.completeness_percentage ?? 0) /
                                    100
                                }
                                color="success"
                                thickness="large"
                            />
                        </SFlexProgress>
                        <SFlexFooter>
                            <SButton
                                content="Compléter ma fiche"
                                icon={<EditIcon />}
                                onClick={() =>
                                    navigate(ROUTES.collaborator_factsheet)
                                }
                            />
                            <SFlexDeadline gap="gap.smaller">
                                <STextDeadline content="⏱ Échéance : " />
                                {isLoading ? (
                                    <Flex>
                                        <Skeleton animation="pulse">
                                            <Skeleton.Line
                                                width="64px"
                                                height="32px"
                                            />
                                        </Skeleton>
                                    </Flex>
                                ) : (
                                    <STextDeadlineValue
                                        content={formatedDueDate}
                                    />
                                )}
                            </SFlexDeadline>
                        </SFlexFooter>
                    </SFlexEnrollementForm>
                    <SFlexDocsBlock>
                        <DocumentComponent
                            data={data}
                            isLoading={isLoading}
                            isFetching={isFetching}
                        />
                    </SFlexDocsBlock>
                </SFlexRightCol>
            </SFlexPage>
            <Footer data={data} />
        </FooterContent>
    );
};

export default withAuth(WelcomePreonboarding);

const SFlexContactRight = styled(Flex)`
    flex-direction: column;
`;
const SFlexDeadline = styled(Flex)``;
const STextDeadline = styled(Text)`
    font-size: 11px;
    color: rgba(255, 255, 255, 0.6);
    display: flex;
    align-items: center;
    gap: 4px;
`;
const STextDeadlineValue = styled(Text)`
    font-size: 11px;
    color: rgba(255, 255, 255, 0.6);
    display: flex;
    align-items: center;
    gap: 4px;
    color: rgba(255, 255, 255, 0.88);
    font-weight: bolder;
`;

const SButton = styled(Button)`
    background: white;
    color: var(--purple);
    border: none;
    border-radius: 8px;
    padding: 9px 18px;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    font-family: inherit;
    transition: all 0.15s;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    gap: 6px;
`;

const SFlexProgressLabel = styled(Flex)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
`;
const STextProgress = styled(Text)`
    font-size: 11px;
    color: rgba(255, 255, 255, 0.65);
`;
const STextPercent = styled(Text)`
    font-size: 12px;
    font-weight: 700;
    color: white;
`;

const STextDescription = styled(Text)`
    font-size: 12px;
    color: rgba(255, 255, 255, 0.72);
    line-height: 1.65;
    margin-bottom: 16px;
`;

const SFlexTopIcon = styled(Flex)`
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    flex-shrink: 0;
`;
const STextTitle = styled(Text)`
    font-size: 16px;
    font-weight: 700;
    color: white;
`;

const SFlexTop = styled(Flex)`
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
`;
const SFlexBody = styled(Flex)``;
const SFlexProgress = styled(Flex)`
    margin-bottom: 16px;
`;
const SFlexFooter = styled(Flex)`
    justify-content: space-between;
`;

const STextLink = styled(Text)`
    font-size: 12px;
    color: var(--purple);
    text-decoration: none;
    white-space: nowrap;
    :hover {
        text-decoration: underline;
    }
    @media ${DEVICE.mobileS} {
        margin-left: 0;
    }
    @media ${DEVICE.mobileL} {
        margin-left: auto;
    }
`;

const STextFullname = styled(Text)`
    font-size: 14px;
    font-weight: 700;
    color: var(--text);
`;
const STextJobTitle = styled(Text)`
    font-size: 12px;
    color: var(--text-sec);
    line-height: 1.4;
    margin-top: 1px;
`;
const SFlexContact = styled(Flex)`
    padding-top: 18px;
    border-top: 1px solid var(--border);
    justify-content: space-between;
    gap: 8px;
    @media ${DEVICE_MAX.laptop} {
        flex-direction: column;
    }
`;
const SFlexWelcomeBody = styled(Flex)`
    flex-direction: column;
    margin-bottom: 22px;
`;
const STextWelcolmeDescription = styled(Text)`
    font-size: 14px;
    color: var(--text-sec);
    line-height: 1.75;
    margin-bottom: 22px;
`;

const STextWelcomeTitle = styled(Text)`
    font-size: 20px;
    font-weight: 700;
    color: var(--text);
    margin-bottom: 10px;
    @media ${DEVICE.mobileS} {
        line-height: 24px;
    }
    @media ${DEVICE.mobileL} {
        line-height: 20px;
    }
`;

const SFlexPage = styled(Flex)`
    max-width: 1240px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    gap: 28px;
    align-items: stretch;
    @media ${DEVICE.mobileS} {
        flex-direction: column;
        padding: 8px 16px 32px;
    }
    @media ${DEVICE.tablet} {
        flex-direction: row;
        padding: 36px 32px 60px;
    }
`;
const SFlexLeftCol = styled(Flex)`
    display: flex;
    flex-direction: column;
    gap: 20px;
    flex: 1;
`;
const SFlexWelcomeBlock = styled(Flex)`
    background: white;
    border: 1px solid var(--border);
    border-radius: 14px;
    padding: 28px 32px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    flex-shrink: 0;
    .strong {
        color: var(--text);
        font-weight: 600;
        font-size: 14px;
        line-height: 1.75;
    }
`;
const SFlexWelcomeImageBlock = styled(Flex)`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 0;
    flex: 1;
    min-height: 0;
    @media ${DEVICE_MAX.laptop} {
        display: none;
    }
`;
const SFlexRightCol = styled(Flex)`
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-self: start;
    @media ${DEVICE.mobileS} {
        max-width: 100%;
    }
    @media ${DEVICE.tablet} {
        max-width: 400px;
    }
`;
const SFlexEnrollementForm = styled(Flex)`
    background: linear-gradient(
        135deg,
        var(--purple) 0%,
        var(--purple-dark) 100%
    );
    border-radius: 14px;
    padding: 22px 24px;
    position: relative;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(74, 71, 163, 0.22);
    width: 100%;
    ::before {
        content: "";
        position: absolute;
        top: -40px;
        right: -40px;
        width: 160px;
        height: 160px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.06);
    }
    ::after {
        content: "";
        position: absolute;
        bottom: -30px;
        right: 60px;
        width: 90px;
        height: 90px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.04);
    }
`;
const SFlexDocsBlock = styled(Flex)`
    background: white;
    border: 1px solid var(--border);
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
`;

const FooterContent = styled(Flex)`
    background: var(--gb, #fafafa);
    min-height: 100vh;
`;

const ImageStyle = styled(Image)`
    @media ${DEVICE.mobileS} {
        display: none;
    }
    @media ${DEVICE.tablet} {
        display: none;
    }
    @media ${DEVICE.laptop} {
        display: flex;
        width: 381px;
        height: 276px;
    }
`;

const DividerStyle = styled(Divider)`
    @media ${DEVICE.mobileS} {
        display: none;
    }
    @media ${DEVICE.tablet} {
        display: none;
    }
    @media ${DEVICE.laptop} {
        display: none;
    }
`;
